var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStampGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8005 17.505C45.7221 8.29324 59.9854 8.29323 67.907 17.505L70.6068 20.6446C72.6201 22.9858 75.1517 24.8251 78.0005 26.0164L81.8207 27.6139C93.0295 32.3012 97.4371 45.8664 91.1241 56.2469L88.9725 59.7847C87.368 62.423 86.401 65.3991 86.1483 68.4765L85.8095 72.6034C84.8154 84.7121 73.2761 93.0958 61.4529 90.2995L57.4233 89.3465C54.4184 88.6358 51.2891 88.6358 48.2842 89.3465L44.2546 90.2995C32.4314 93.0958 20.8921 84.7121 19.898 72.6034L19.5591 68.4765C19.3065 65.3991 18.3395 62.423 16.735 59.7847L14.5834 56.2469C8.27037 45.8664 12.678 32.3012 23.8868 27.6139L27.707 26.0164C30.5558 24.8251 33.0874 22.9858 35.1007 20.6446L37.8005 17.505Z",
    fill: "#F8961E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.8532,
    cy: 52.8532,
    r: 31.3903,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 28.5,
    stroke: "#F8961E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampGold);
export default __webpack_public_path__ + "static/media/stamp_gold.ae9e05a2891619fa8aab8f56cceced3e.svg";
export { ForwardRef as ReactComponent };